const getDefaultState = () => ({
  theme:
    process.env.VUE_APP_FROM_PROJECT ?? import.meta.env.VITE_APP_FROM_PROJECT
});
const mutations = {
  SET_THEME(state, { theme }) {
    state.theme = theme;
  }
};
const actions = {
  async setTheme({ commit, rootState, state }, theme) {
    commit('SET_THEME', { theme });
    document.body.setAttribute('data-theme', theme);
  }
};
const getters = {
  getTheme: (state) => state.theme
};
const state = getDefaultState;
export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state
};
